import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-on-premise-grammar-checker',
  templateUrl: './on-premise-grammar-checker.component.html',
  styleUrls: ['./on-premise-grammar-checker.component.scss']
})
export class OnPremiseGrammarCheckerComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle("企業專用本地部署文法檢查器 | Trinka AI");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka AI 提供強大且安全的企業本地部署文法檢查解決方案，具備無與倫比的資料安全性、可客製化功能、無縫整合以及專業技術支援。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "企業專用本地部署文法檢查器 | Trinka AI" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka AI 提供強大且安全的企業本地部署文法檢查解決方案，具備無與倫比的資料安全性、可客製化功能、無縫整合以及專業技術支援。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/on-premise-grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/on-premise-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/on-premise-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/on-premise-grammar-checker' });
    //this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/on-premise-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/on-premise-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/on-premise-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/on-premise-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/on-premise-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/on-premise-grammar-checker' });
  }

}
